import styled from 'styled-components'
import { em } from 'polished'

import { BoxBase } from 'styles/components/layout'
import { Text } from 'shared/Typography'

import bg from './assets/bg.png'
import bg_mob from './assets/bg_mob.png'

export const Wrapper = styled.div`
  padding-top: ${em(40)};
  padding-bottom: ${em(320)};
  background-color: #655E54;
  background-repeat: no-repeat;
  background-position: right bottom;
  background-image: url(${bg_mob});
  background-size: 100% auto;

  ${p => p.theme.mq.upMd} {
    background-size: 40%;
  }

  ${p => p.theme.mq.upLg} {
    padding-top: ${em(70)};
    padding-bottom: ${em(128)};
    background-image: url(${bg});
    background-size: contain;
  }
`

export const Container = styled(BoxBase)`
  display: flex;
  flex-direction: column;
  gap: ${em(10)};
  color: var(--color-W100);

  ${p => p.theme.mq.upLg} {
    gap: ${em(25)};
  }
`

export const Title = styled(Text)`
  ${({ theme }) => theme.mq.upLg} {
    max-width: ${em(450, 65)};
  }

  span {
    color: var(--color-Y50);
  }

`

export const Description = styled(Text)`
  ${({ theme }) => theme.mq.upLg} {
    max-width: ${em(443, 22)};
  }

  & > p:first-of-type {
    max-width: ${em(370, 22)};

    ${({ theme }) => theme.mq.upLg} {
      margin-bottom: ${em(30, 22)};
    }
  }
`
